<template>
    <div
        id="detailScrollContainer"
        ref="detailScrollContainer"
        :class="{
            invertedBack: store.inverted && !store.fullscreen,
            allowScroll: allowBottomScroll
        }"
    >
        <div id="detailContainer" ref="detailContainer">
            <!--
        <Menu :imageCounter="firstImage.counter" v-if="!bottomMobile" page="detail" ></Menu>
        -->

            <div v-if="$mq != 'mobile'" id="counter">
                <span class="tabNum"
                    >{{ formatNumber(firstImage.counter) }}/{{
                        formatNumber(store.totalImages)
                    }}</span
                >
            </div>
            <div
                id="detail"
                @click.stop="handleClick"
                v-if="!bottomMobile"
                :class="{ bottom: bottom }"
                v-touch:swipe.right="handleBackClick"
                v-touch:swipe.left="handleClick"
            >
                <!--
                <div id="doubleImageCont" v-if="getImage.is_paired_with_next">
                    <div class="doubleImageFlex">
                    <img id="preloader" :src="getImage.thumbnail_small">
                    <img class="preloader2" :src="getDouble.thumbnail_small">
                    <img v-if="getDouble.is_paired_with_next" class="preloader2" :src="getTriple.thumbnail_small" alt="">
                    </div>
                    <div class="doubleImageFlex">
                    <img class="doubleImage" v-show="imageVisible" @load="makeVisible" :src="getImage.thumbnail_big":class="{hasBorder: getImage.has_border}">
                    <img class="doubleImage" v-show="imageVisible2" @load="makeVisible2" :class="{hasBorder: getDouble.has_border}" :src="getDouble.thumbnail_big">
                    <img v-if="getDouble.is_paired_with_next" v-show="imageVisible3" @load="makeVisible3" class="doubleImage" :src="getTriple.thumbnail_big" alt="" :class="{hasBorder: getTriple.has_border}">
                    </div>
                </div>
            -->
                <div v-if="!firstImage.video">
                    <!--
                    <div id="preloaderCont">
                        <img v-show="previewVisible" @load="makePreviewVisible" class="preloader" :src="getImage.thumbnail_small">
                        <img v-show="previewVisible" @load="makePreviewVisible" v-if="getImage.is_paired_with_next" class="preloader" :src="getDouble.thumbnail_small" alt="">
                        <img v-show="previewVisible" @load="makePreviewVisible" v-if="getImage.is_paired_with_next && getDouble.is_paired_with_next" class="preloader" :src="getTriple.thumbnail_small" alt="">
                    </div>
                    -->
                    <transition appear name="appear">
                        <div class="lds-spinner" v-if="spinnerVisible">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </transition>
                    <transition appear :name="getTransition">
                        <div id="imageCont" v-show="imageVisible">
                            <template>
                                <img
                                    class="image"
                                    :key="imageKey"
                                    ref="image"
                                    @load="makeVisible(firstImage.id)"
                                    :src="
                                        store.fullscreen
                                            ? ''
                                            : getSource(firstImage)
                                    "
                                    :style="detailStyle"
                                    :class="{
                                        fullscreen: store.fullscreen,
                                        websiteImage: firstImage.is_website,
                                        lightBorder: firstImage.border == 'LI',
                                        darkBorder: firstImage.border == 'DA'
                                    }"
                                />
                            </template>
                            <template v-if="secondImage">
                                <img
                                    @load="makeVisible(secondImage.id)"
                                    class="image"
                                    :src="getSource(secondImage)"
                                    alt=""
                                    :class="{
                                        lightBorder: secondImage.border == 'LI',
                                        darkBorder: secondImage.border == 'DA',
                                        websiteImage: secondImage.is_website
                                    }"
                                />
                            </template>
                            <template v-if="thirdImage">
                                <img
                                    @load="makeVisible(thirdImage.id)"
                                    class="image"
                                    :src="getSource(thirdImage)"
                                    alt=""
                                    :class="{
                                        lightBorder: thirdImage.border == 'LI',
                                        darkBorder: thirdImage.border == 'DA',
                                        websiteImage: thirdImage.is_website
                                    }"
                                />
                            </template>
                        </div>
                    </transition>
                </div>
                <div v-else>
                    <transition appear name="appear">
                        <div class="lds-spinner" v-if="!videoVisible">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </transition>
                    <transition appear :name="getTransition">
                        <div id="imageCont" v-show="videoVisible">
                            <div>
                                <video
                                    id="video"
                                    :key="imageKey"
                                    ref="image"
                                    @canplay="makeVideoVisible"
                                    :class="{
                                        websiteVideo: firstImage.is_website
                                    }"
                                    muted
                                    loop
                                    autoplay
                                    playsinline
                                >
                                    <source
                                        :src="firstImage.video"
                                        type="video/mp4"
                                    />
                                </video>
                            </div>
                        </div>
                    </transition>
                </div>
                <div
                    v-if="store.random == false && !bottom"
                    id="leftClick"
                    @click.stop="handleBackClick"
                ></div>
                <div
                    v-if="store.random == false && !bottom && $mq != 'mobile'"
                    id="middleClick"
                    :class="{ hasBottom: project.text || project.infos.length }"
                    @click.stop="handleMiddleClick"
                ></div>
                <div
                    v-if="store.random == false && !bottom"
                    id="rightClick"
                    @click.stop="handleClick"
                ></div>
                <a
                    v-if="firstImage.eyecatcher_url"
                    @click.stop
                    :href="firstImage.eyecatcher_url"
                    target="_blank"
                    id="eyeCatcher"
                    ><span>{{ firstImage.eyecatcher_text }}</span></a
                >
                <span
                    v-else-if="firstImage.eyecatcher_text"
                    @click.stop
                    id="eyeCatcher"
                    ><span>{{ firstImage.eyecatcher_text }}</span></span
                >
                <!--
        <div id="counter" class="mobileCounter" v-if="store.isMobile == true" :class="{inverted: store.inverted && !store.fullscreen || store.fullscreen && store.inverted && !bottom}">
            <span id="indexNumber">
            {{ getImage.counter }}/{{ store.totalImages }}
            </span>
            <span v-if="store.random" class="toggleRandom toggleRandomMobile" @click="toggleRandom">&#xe011;</span>
            <span v-else class="toggleRandom toggleRandomMobile" @click="toggleRandom">&#xe010;</span>
        </div>
-->
            </div>
            <!--
    <div v-if="$mq === 'none'" id="bottom" class="mobile">
        <div id="bottomTopMobile" :class="{inverted: store.inverted && !store.fullscreen || store.fullscreen && store.inverted && !bottom}">

            <div v-if="project" id="titleMobile" :class="{inverted: store.inverted && !store.fullscreen || store.fullscreen && store.inverted && !bottom}">
            <span>
                {{ project.title }}
            </span>
            <span id="toggleBottom" :class="{inverted: store.inverted}" @click="bottomMobile=!bottomMobile">Show Info</span>
            </div>
            <div id="bottomLinkMobile">
            <router-link :to="{ name: 'studio'}">About</router-link>
            <a href="/#/index" :class="{inverted: store.inverted}" @click.prevent="gotoIndex">Index</a>
            </div>
        </div>
    </div>
    -->
            <div id="bottom">
                <div
                    id="bottomTop"
                    :class="{
                        inverted:
                            (store.inverted && !store.fullscreen) ||
                            (store.fullscreen && store.inverted && !bottom)
                    }"
                >
                    <div
                        v-if="project"
                        id="title"
                        @click.stop="handleMiddleClick"
                        class="toggle"
                    >
                        <div v-if="$mq == 'mobile'" id="counter">
                            <span class="tabNum"
                                >{{ formatNumber(firstImage.counter) }}/{{
                                    formatNumber(store.totalImages)
                                }}</span
                            >
                        </div>
                        <div id="titleText">
                            <span v-if="project.title"
                                >{{ project.title }},
                            </span>
                            <span v-else> </span>
                            <span class="nobreak" v-if="project.category.name"
                                >{{ project.category.name }},
                                <span
                                    v-html="formatYear(project.year_order)"
                                ></span>
                            </span>
                            <span class="nobreak" v-else>
                                <span> </span>
                            </span>
                        </div>
                        <!--
            <span id="toggleBottom" :class="{inverted: store.inverted}" @click="toggleBottom" v-html="bottom ? 'Close' : 'Info'">
            </span>
            -->
                    </div>
                    <!--
            <div v-if="!bottom">
                <a href="/#/index" :class="{inverted: store.inverted}" @click.prevent="gotoIndex">Index</a>
            </div>
            <div id="detailSpacer">
            </div>
            -->
                </div>
            </div>

            <div class="lds-spinner lds-spinner2" v-show="!imagesVisible">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div v-if="project" id="projectImages" v-show="imagesVisible">
                <section v-if="$mq == 'desktop'">
                    <div
                        v-if="render"
                        v-for="(image, idx) in projectImages"
                        class="imageElement"
                        :style="{
                            width: getDivWidth(image),
                            flexGrow: getDivFlex(image)
                        }"
                    >
                        <i :style="{ paddingBottom: getIPadding(image) }"></i>
                        <img
                            :src="image.thumbnail_med"
                            class="projectImage"
                            @load="checkProjectImage"
                            :class="{
                                double: image.is_paired_with_next,
                                triple:
                                    image.is_paired_with_next &&
                                    getNextImage(image).is_paired_with_next,
                                websiteImage: image.is_website,
                                lightBorder: image.border == 'LI',
                                darkBorder: image.border == 'DA'
                            }"
                            alt=""
                            @click="handleProjectClick(image)"
                        />
                        <img
                            v-if="image.is_paired_with_next"
                            class="projectImage"
                            :class="{
                                double: image.is_paired_with_next,
                                triple:
                                    image.is_paired_with_next &&
                                    getNextImage(image).is_paired_with_next,
                                lightBorder: getNextImage(image).border == 'LI',
                                darkBorder: getNextImage(image).border == 'DA',
                                websiteImage: getNextImage(image).is_website
                            }"
                            :src="getNextImage(image).thumbnail_med"
                            alt=""
                            @click="handleProjectClick(image)"
                        />
                        <img
                            v-if="
                                image.is_paired_with_next &&
                                    getNextImage(image).is_paired_with_next
                            "
                            class="triple projectImage"
                            :src="getThirdImage(image).thumbnail_med"
                            alt=""
                            @click="handleProjectClick(image)"
                            :class="{
                                lightBorder:
                                    getThirdImage(image).border == 'LI',
                                darkBorder: getThirdImage(image).border == 'DA',
                                websiteImage: getThirdImage(image).is_website
                            }"
                        />
                        <p class="tabNum">
                            {{ formatPosition(image.counter) }}
                        </p>
                    </div>
                </section>
                <section v-else id="mobileImages">
                    <div v-for="(image, idx) in projectImages" class="">
                        <!--
                <img :src="image.thumbnail_med" class="projectImage" :class="{websiteImage: image.is_website}" alt="" @click="handleProjectClick(image)">
                -->
                        <img
                            :src="image.thumbnail_med"
                            class="projectImage"
                            @load="checkProjectImage"
                            :class="{
                                double: image.is_paired_with_next,
                                triple:
                                    image.is_paired_with_next &&
                                    getNextImage(image).is_paired_with_next,
                                websiteImage: image.is_website,
                                lightBorder: image.border == 'LI',
                                darkBorder: image.border == 'DA'
                            }"
                            alt=""
                            @click="handleProjectClick(image)"
                        />
                        <img
                            v-if="image.is_paired_with_next"
                            class="projectImage"
                            :class="{
                                double: image.is_paired_with_next,
                                triple:
                                    image.is_paired_with_next &&
                                    getNextImage(image).is_paired_with_next,
                                lightBorder: getNextImage(image).border == 'LI',
                                darkBorder: getNextImage(image).border == 'DA',
                                websiteImage: getNextImage(image).is_website
                            }"
                            :src="getNextImage(image).thumbnail_med"
                            alt=""
                            @click="handleProjectClick(image)"
                        />
                        <img
                            v-if="
                                image.is_paired_with_next &&
                                    getNextImage(image).is_paired_with_next
                            "
                            class="projectImage triple"
                            :src="getThirdImage(image).thumbnail_med"
                            alt=""
                            @click="handleProjectClick(image)"
                            :class="{
                                lightBorder:
                                    getThirdImage(image).border == 'LI',
                                darkBorder: getThirdImage(image).border == 'DA',
                                websiteImage: getThirdImage(image).is_website
                            }"
                        />
                        <p class="tabNum">
                            {{ formatPosition(image.counter) }}
                        </p>
                    </div>
                </section>
            </div>

            <div
                v-if="project"
                id="description"
                :class="{
                    inverted: store.inverted && !store.fullscreen,
                    visible: bottom
                }"
            >
                <!--
            <p>{{ project.category.name }}, {{ formatYear(project.year) }}</p>
            -->
                <p id="text" v-html="project.text"></p>
                <div v-if="project.infos.length || project.link" id="infos">
                    <p
                        class="tabNum"
                        v-for="info in project.infos"
                        v-html="info.text"
                    ></p>
                    <a :href="project.link" target="_blank">{{
                        project.link_text
                    }}</a>
                </div>
            </div>

            <!--
        <div v-else-if="project && $mq == 'mobile' && bottomMobile" id="bottomMobile">
            <div class="text">
            <p>{{ project.category.name }}, {{ formatYear(project.year) }}</p>
            <p id="text" v-html="project.text"></p>
            <div id="infos">
            <p class="tabNum" v-for="info in project.infos" v-html="info.text"></p>
            <a :href="project.link">{{ project.link_text }}</a>
            </div>
            </div>
            <div class="hide">
            <p class="title">{{ project.title }}</p>
                <p class="text" @click="bottomMobile=!bottomMobile">
                    Hide Info
                </p>

            </div>
        </div>
        --></div>
    </div>
</template>

<script>
import { store } from "@/centralStore";
import api from "@/api";
import Menu from "@/components/Menu";

export default {
    name: "Detail",
    components: {
        Menu
    },
    data() {
        return {
            project: {
                category: "",
                infos: []
            },
            store: store.state,
            //currentImage: null,
            imageKey: 0,
            bottom: false,
            bottomMobile: false,
            imageVisible: false,
            spinnerVisible: false,
            previewVisible: false,
            //imageVisible2: false,
            //imageVisible3: false,
            imageNumber: 0,
            imageCount: 0,
            previewCount: 0,
            firstImage: {
                counter: 0
            },
            secondImage: null,
            thirdImage: null,
            //firstImageLoaded: false;
            //secondImageLoaded: false;
            //thirdImageLoaded: false;
            loadedImages: [],
            videoVisible: false,
            scrollTimeout: false,
            allowBottomScroll: false,
            //mounted: false,
            //slug: '',
            //id: '',
            render: false,
            //imageCounter: 0,
            projectImages: [],
            //time1: 0,
            //time2: 0,
            lastScrollDelta: 0,
            imagesVisible: false,
            visibleImages: 0
        };
    },
    watch: {
        "store.imagesReady": function(val) {
            let myself = this;
            if (val == true) {
                myself.checkRoute();

                if (!myself.getImage.video) {
                    myself.imageNumber = 1;
                    myself.firstImage = myself.getImage();
                    if (
                        myself.firstImage.is_paired_with_next &&
                        window.innerWidth > 8
                    ) {
                        myself.imageNumber = 2;
                        myself.secondImage = myself.getDouble();
                        if (myself.secondImage.is_paired_with_next) {
                            myself.imageNumber = 3;
                            myself.thirdImage = myself.getTriple();
                        }
                    }
                }
            }
        },
        project: function(val, oldval) {
            if (val.images.length > 0) {
                let myself = this;
                //let counter = 1;
                let imageCounter = 0;
                let pairMark = false;
                this.project.images.forEach(image => {
                    //image.counter = counter
                    if (!pairMark || window.innerWidth <= 8) {
                        myself.projectImages.push(image);
                        //counter += 1;
                    } else {
                        pairMark = false;
                    }
                    if (image.is_paired_with_next && window.innerWidth > 8) {
                        pairMark = true;
                    }

                    let img = new Image();
                    img.src = image.thumbnail_med;
                    img.onload = () => {
                        image.width = img.width;
                        image.height = img.height;
                        imageCounter += 1;
                        if (imageCounter == val.images.length) {
                            myself.render = true;
                        }
                    };
                });
            }
        }
        //'$route' (to, from) {
        //const toDepth = to.path.split('/').length
        //const fromDepth = from.path.split('/').length
        //this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        //this.transitionName = 'slideUp'
        //if (to.name == 'index' || to.name == 'images'){
        //this.transitionName = 'slideUp'
        //} else {
        //this.transitionName = null
        //}
        //console.log(this.transitionName)
        //}
    },
    props: {},
    //beforeRouteUpdate (to, from, next) {
    //var myself = this;
    //myself.checkRoute();
    //this.imageVisible = false;
    //next();
    //},
    mounted() {
        var myself = this;

        setTimeout(function() {
            if (!myself.imageVisible) {
                myself.spinnerVisible = true;
            }
        }, 200);

        myself.checkRoute();
        if (!myself.getImage.video) {
            myself.imageNumber = 1;
            myself.firstImage = myself.getImage();
            if (
                myself.firstImage.is_paired_with_next &&
                window.innerWidth > 8
            ) {
                myself.imageNumber = 2;
                myself.secondImage = myself.getDouble();
                if (myself.secondImage.is_paired_with_next) {
                    myself.imageNumber = 3;
                    myself.thirdImage = myself.getTriple();
                }
            }
        }
        //this.mounted = true;

        //this.store.listTransition = 'slideUp'

        if (window.innerWidth > 768) {
            window.addEventListener("wheel", this.handleScroll);
            window.addEventListener("keydown", this.handleKey);
        }
        document.body.classList.add("index");
    },
    deactivated() {
        //this.imageVisible = false;
        //this.imageVisible2 = false;
        //this.imageVisible = false;
        //setTimeout(function(){
        //this.imageCount = 0;
        //this.imageVisible = false;
        //this.fistImage = {counter: 0};
        //this.secondImage = null;
        //this.thirdImage = null;
        //}, 500)
        //window.removeEventListener("wheel", this.handleScroll)
        //window.removeEventListener("keydown", this.handleKey)
    },
    unmounted() {},
    updated() {},
    beforeRouteLeave(to, from, next) {
        window.removeEventListener("wheel", this.handleScroll);
        window.removeEventListener("keydown", this.handleKey);
        document.body.classList.remove("index");
        next();
    },
    beforeRouteUpdate(to, from, next) {
        window.removeEventListener("wheel", this.handleScroll);
        window.removeEventListener("keydown", this.handleKey);
        document.body.classList.remove("index");
        this.store.lastSlug = this.store.activeSlug;
        next();
    },
    activated() {
        var myself = this;
        this.store.detailTransition = "";
        this.bottom = false;
        //if (window.innerWidth > 480){
        //window.addEventListener("wheel", this.handleScroll)
        //}
        //if (window.innerWidth > 480){
        //window.addEventListener("wheel", this.handleScroll)
        //window.addEventListener("keydown", this.handleKey)
        //}

        //if (window.innerWidth > 480){
        //if (myself.scrollListener == false){
        //window.addEventListener("wheel", this.handleScroll)
        //window.addEventListener("keydown", this.handleKey)
        //myself.scrollListener = true
        //}
        //}

        //this.imageVisible = true;

        //window.addEventListener("scroll", this.handleScroll)
        if (this.project) {
            this.imageKey = Math.floor(Math.random() * (100 - 0 + 1)) + 0;
        }

        myself.checkRoute();
        //console.log('da')

        if (!myself.getImage.video) {
            myself.imageNumber = 1;
            myself.firstImage = myself.getImage();
            if (
                myself.firstImage.is_paired_with_next &&
                window.innerWidth > 8
            ) {
                myself.imageNumber = 2;
                myself.secondImage = myself.getDouble();
                if (myself.secondImage.is_paired_with_next) {
                    myself.imageNumber = 3;
                    myself.thirdImage = myself.getTriple();
                }
            }
        }
        //console.log('activated')
        //        var counter = 1;
        //        var images = [];
        //        var sortedProjects =  myself.store.projects.sort((a,b) => {
        //            if (myself.store.sorting == 'type'){
        //                if (a.category.name < b.category.name){
        //                    return -1 * myself.store.sortingOrder;
        //                }
        //                if (a.category.name > b.category.name){
        //                    return 1 * myself.store.sortingOrder;
        //                }
        //
        //                //} else if (myself.sorting == 'images'){
        //                    //if (a.images.length < b.images.length){
        //                        //return -1 * myself.sortingOrder;
        //                    //}
        //                    //if (a.images.length > b.images.length){
        //                        //return 1 * myself.sortingOrder;
        //                    //}
        //
        //            } else {
        //                if (a[myself.store.sorting] < b[myself.store.sorting]){
        //                    return -1 * myself.store.sortingOrder;
        //                }
        //                if (a[myself.store.sorting] > b[myself.store.sorting]){
        //                    return 1 * myself.store.sortingOrder;
        //                }
        //            }
        //            return 0;
        //        })
        //        sortedProjects.forEach(project => {
        //            project.images.forEach(img => {
        //                img.counter = counter;
        //                images.push(img);
        //                counter += 1;
        //            })
        //        })
        //        myself.store.orderedImages = images;
    },
    computed: {
        //getSource: function(image){
        //return image.thumbnail_big
        //},
        getTransition() {
            if (this.store.lastSlug != this.store.activeSlug) {
                return "long-appear";
            } else {
                return "short-appear";
            }
        }
    },
    methods: {
        testSwipe(direction, event) {
            console.log(direction);
            console.log(event);
        },
        getSource(image) {
            if (
                typeof image.image != "undefined" &&
                image.image.endsWith("gif")
            ) {
                return image.image;
            } else {
                return image.thumbnail_big;
            }
        },
        handleScroll(e) {
            let myself = this;
            if (!myself.scrollTimeout) {
                if (Math.abs(e.deltaY) >= myself.lastScrollDelta) {
                    myself.lastScrollDelta = Math.abs(e.deltaY);
                    if (e.deltaY < 0) {
                        myself.toggleTop();
                    } else if (e.deltaY > 0 && !myself.bottom) {
                        myself.toggleBottom();
                    }
                    myself.scrollTimeout = true;
                }
                setTimeout(function() {
                    myself.scrollTimeout = false;
                    myself.lastScrollDelta = 0;
                }, 100);
                //console.log('deltaY', e.deltaY)
                //console.log('lastScrollDelta', myself.lastScrollDelta)
            }
        },
        handleMiddleClick() {
            if (this.bottom) {
                this.toggleTop();
            } else {
                this.toggleBottom();
            }
        },
        formatNumber(number) {
            if (number && number != "" && number != 0) {
                return number.toString().padStart(3, "0");
            } else {
                return "000";
            }
        },
        formatYear(date) {
            //if (this.project.start_year){

            //let str = new Date(this.project.start_year).getFullYear() + '&ndash;' + new Date(this.project.end_year).getFullYear()
            //return str
            //} else if (this.project.end_year){
            //return new Date(this.project.end_year).getFullYear()
            //} else {
            //return new Date().getFullYear()
            //}
            var str;
            if (this.project.start_year && this.project.end_year) {
                str =
                    new Date(this.project.start_year).getFullYear() +
                    "&ndash;" +
                    new Date(this.project.end_year)
                        .getFullYear()
                        .toString()
                        .substr(-2);
            } else if (this.project.start_year) {
                if (this.project.ongoing) {
                    str =
                        new Date(this.project.start_year).getFullYear() +
                        "&ndash;" +
                        new Date()
                            .getFullYear()
                            .toString()
                            .substr(-2);
                } else {
                    str = new Date(this.project.start_year).getFullYear();
                }
            } else if (this.project.end_year) {
                str = new Date(this.project.end_year).getFullYear();
            }
            return str;
        },

        getImage() {
            if (this.store.currentImage) {
                let myself = this;
                setTimeout(function() {
                    let imageShell = new Image();
                    let image;
                    if (myself.store.random) {
                        if (
                            myself.store.randomIndex <
                            myself.store.shuffledImages.length - 1
                        ) {
                            image =
                                myself.store.shuffledImages[
                                    myself.store.randomIndex + 1
                                ];
                        } else {
                            image = myself.store.shuffledImages[0];
                        }
                    } else {
                        var index = myself.store.orderedImages.indexOf(
                            myself.store.currentImage
                        );
                        if (
                            index >= 0 &&
                            index < myself.store.orderedImages.length - 1
                        ) {
                            var nextIndex = index + 1;
                        } else {
                            var nextIndex = 0;
                        }
                        image = myself.store.orderedImages[nextIndex];
                    }
                    imageShell.src = myself.getSource(image);
                }, 100);

                //let imageShell2 = new Image();
                //if (this.store.orderedIndex < this.store.orderedImages.length -1){
                //let image2 = this.store.orderedImages[this.store.orderedIndex + 1];
                //} else {
                //let image2 = this.store.orderedImages[0];
                //}
                //imageShell2.src = image2.thumbnail_big;
                return this.store.currentImage;
            } else {
                return "";
            }
        },
        detailStyle() {
            if (this.store.fullscreen) {
                //this.imageVisible = true;
                return (
                    "backgroundImage: url('" +
                    this.getImage.thumbnail_big +
                    "')"
                );
            }
        },
        getDouble() {
            let allImagesIdx = this.store.allImages.findIndex(
                i => i.id == this.firstImage.id
            );
            return this.store.allImages[allImagesIdx + 1];
            //return this.store.allImages[this.store.currentImage.counter]
        },
        getTriple() {
            let allImagesIdx = this.store.allImages.findIndex(
                i => i.id == this.firstImage.id
            );
            return this.store.allImages[allImagesIdx + 2];
        },
        makePreviewVisible() {
            let myself = this;
            myself.previewCount += 1;
            if (myself.previewCount == myself.imageNumber) {
                myself.previewVisible = true;
            }
        },
        makeVisible(id) {
            let myself = this;
            //setTimeout(function(){
            //myself.imageVisible = true;
            //}, 1000)
            if (!myself.loadedImages.includes(id)) {
                myself.loadedImages.push(id);
            }
            if (myself.loadedImages.length == myself.imageNumber) {
                myself.imageVisible = true;
                myself.spinnerVisible = false;
            }
        },
        makeVideoVisible() {
            this.videoVisible = true;
        },
        //makeVisible2(el){
        //let myself = this;
        //setTimeout(function(){
        //myself.imageVisible2 = true;
        //}, 1000)
        //},
        //makeVisible3(){
        //let myself = this;
        //setTimeout(function(){
        //myself.imageVisible3 = true;
        //}, 1000)
        //},
        gotoIndex() {
            this.store.detailTransition = "slideUp";
            if (this.store.lastIndex == "images") {
                this.store.imagesTransition = "slideDown";
            } else {
                this.store.indexTransition = "slideDown";
            }
            let myself = this;
            setTimeout(function() {
                myself.$router.push({ name: myself.store.lastIndex });
            }, 100);
        },
        checkRoute() {
            var myself = this;
            if (myself.store.imagesReady) {
                if (myself.$route.params.slug) {
                    myself.store.activeSlug = myself.$route.params.slug;
                    myself.project = myself.store.projects.find(
                        project => project.slug == myself.store.activeSlug
                    );
                    if (myself.$route.params.id) {
                        myself.store.activeID = myself.$route.params.id;
                    } else {
                        //var image = myself.project.images.find(image => image.level == 'TL');
                        var image = myself.project.images[0];
                        myself.store.activeID = image.id;
                    }
                } else {
                    if (myself.store.currentImage) {
                        myself.project = myself.store.projects.find(
                            project =>
                                project.slug ==
                                myself.store.currentImage.project_slug
                        );
                        myself.store.activeID = myself.store.currentImage.id;
                    } else {
                        //myself.store.activeSlug = myself.store.shuffledImages[0].project_slug;
                        //myself.project = myself.store.projects.find(project => project.slug == myself.store.activeSlug);
                        //var image = myself.project.images.find(image => image.level == 'TL');
                        //var image = myself.project.images[0];
                        //myself.store.activeID = image.id;
                        myself.store.activeID =
                            myself.store.shuffledImages[0].id;
                        myself.project = myself.store.projects.find(
                            project =>
                                project.id ==
                                myself.store.shuffledImages[0].project
                        );
                    }
                }
                myself.setImage(
                    myself.project.images.find(
                        image => image.id == myself.store.activeID
                    )
                );
                //console.log('checkroute')
                //myself.$router.push({ name: 'detail-image', params: { slug: myself.slug, id: myself.id } })
                //console.log('check route')
            }
        },
        toggleTop() {
            if (window.innerWidth > 768) {
                this.$refs.detailContainer.style.marginTop = "0";
                if (this.getImage.fullscreen) {
                    this.$refs.image.style.marginTop = "0";
                }
            } else {
                let myself = this;
                setTimeout(function() {
                    myself.$refs.detailScrollContainer.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth"
                    });
                }, 100);
                this.allowBottomScroll = false;
            }
            this.bottom = false;
        },
        toggleBottom() {
            let myself = this;

            if (window.innerWidth > 768) {
                var rem = 0;
                var contentHeight =
                    this.$refs.detailContainer.offsetHeight + rem;
                var windowHeight = window.innerHeight;

                var margin = windowHeight - contentHeight;
                this.$refs.detailContainer.style.marginTop = margin + "px";
            } else {
                this.allowBottomScroll = true;
                let myself = this;
                //this.$refs.detailScrollContainer.scroll({top: 50, left: 0, behavior: 'smooth'})
                setTimeout(function() {
                    myself.$refs.detailScrollContainer.scroll({
                        top: 200,
                        left: 0,
                        behavior: "smooth"
                    });
                }, 100);
            }
            this.bottom = true;
        },
        toggleBottomMobile() {
            //console.log('toggle bottom mobile')
        },
        setImage(image) {
            this.store.currentImage = image;
            //this.store.inverted = image.inverted;
            this.store.fullscreen = image.fullscreen;
            //console.log('set image')
        },
        toggleRandom() {
            this.store.random = !this.store.random;
        },
        handleClick() {
            if (this.bottom) {
                this.toggleTop();
            } else {
                this.gotoNextImage();
            }
        },
        handleBackClick() {
            if (this.bottom) {
                this.toggleTop();
            } else {
                this.gotoPrevImage();
            }
        },
        gotoNextImage() {
            var myself = this;
            if (myself.store.random == true) {
                var index = myself.store.randomIndex;
                if (
                    index >= 0 &&
                    index < myself.store.shuffledImages.length - 1
                ) {
                    var nextIndex = index + 1;
                } else {
                    var nextIndex = 0;
                }
                var nextImage = myself.store.shuffledImages[nextIndex];
                myself.store.randomIndex = nextIndex;
                myself.$router.push({
                    name: "detail-image",
                    params: { slug: nextImage.project_slug, id: nextImage.id }
                });
            } else {
                var index = myself.store.orderedImages.indexOf(
                    myself.store.currentImage
                );
                if (
                    index >= 0 &&
                    index < myself.store.orderedImages.length - 1
                ) {
                    var nextIndex = index + 1;
                } else {
                    var nextIndex = 0;
                }
                var nextImage = myself.store.orderedImages[nextIndex];
                myself.store.orderedIndex = nextIndex;
                myself.$router.push({
                    name: "detail-image",
                    params: { slug: nextImage.project_slug, id: nextImage.id }
                });
            }
        },

        gotoPrevImage() {
            var myself = this;
            //if (myself.store.random == true){
            //var index = myself.store.randomIndex;
            //if(index >= 0 && index < myself.store.shuffledImages.length - 1){
            //var nextIndex = index + 1;
            //} else {
            //var nextIndex = 0;
            //}
            //var nextImage = myself.store.shuffledImages[nextIndex];
            //myself.store.randomIndex = nextIndex;
            //myself.$router.push({ name: 'detail-image', params: { slug: nextImage.project_slug, id: nextImage.id } })
            //} else {
            var index = myself.store.orderedImages.indexOf(
                myself.store.currentImage
            );
            if (index >= 1 && index <= myself.store.orderedImages.length - 1) {
                var nextIndex = index - 1;
            } else {
                var nextIndex = myself.store.orderedImages.length - 1;
            }
            var nextImage = myself.store.orderedImages[nextIndex];
            myself.store.orderedIndex = nextIndex;
            myself.$router.push({
                name: "detail-image",
                params: { slug: nextImage.project_slug, id: nextImage.id }
            });

            //}
        },
        gotoNextProject() {
            //var projectIndex = this.store.projects.findIndex(project => project.id == this.project.id);
            //if(projectIndex >= 0 && projectIndex < this.store.projects.length - 1){
            //var nextProject = this.store.projects[projectIndex + 1];
            //this.$router.push({ name: 'detail', params: { slug: nextProject.slug } })
            //} else if (projectIndex >= this.store.projects.length - 1){
            //this.$router.push({ name: 'detail', params: { slug: this.store.projects[0].slug } })
            //}
        },

        handleProjectClick(image) {
            let myself = this;
            this.store.random = false;
            this.toggleTop();
            //this.store.imagesTransition = 'slideDown';
            //this.store.detailTransition = 'slideUp';
            //setTimeout(function(){
            //myself.$router.push({ name: 'detail-image', params: { slug: image.project_slug, id: image.id } })
            //}, 100)
            setTimeout(function() {
                myself.$router.push({
                    name: "detail-image",
                    params: { slug: image.project_slug, id: image.id }
                });
            }, 500);
        },
        formatPosition(position) {
            return position.toString().padStart(3, "0");
        },
        getDivWidth(image) {
            if (
                image.is_paired_with_next &&
                this.getNextImage(image).is_paired_with_next
            ) {
                //return image.width*360/image.height + window.innerWidth*0.005 + 'px'
                return (
                    (image.width * 370) / image.height +
                    window.innerWidth * 0.005 +
                    "px"
                );
            } else if (image.is_paired_with_next) {
                return (
                    (image.width * 240) / image.height +
                    window.innerWidth * 0.005 +
                    "px"
                );
            } else {
                return (image.width * 120) / image.height + "px";
            }
        },
        getDivFlex(image) {
            if (
                image.is_paired_with_next &&
                this.getNextImage(image).is_paired_with_next
            ) {
                return (image.width * 360) / image.height;
            } else if (image.is_paired_with_next) {
                return (image.width * 240) / image.height;
            } else {
                return (image.width * 120) / image.height;
            }
        },
        getIPadding(image) {
            if (
                image.is_paired_with_next &&
                this.getNextImage(image).is_paired_with_next
            ) {
                return (image.height / image.width) * 32 + "%";
            } else if (image.is_paired_with_next) {
                return (image.height / image.width) * 48.5 + "%";
            } else {
                return (image.height / image.width) * 101 + "%";
            }
        },
        getNextImage(image) {
            let allImagesIdx = this.store.allImages.findIndex(
                i => i.id == image.id
            );
            return this.store.allImages[allImagesIdx + 1];
        },
        getThirdImage(image) {
            let allImagesIdx = this.store.allImages.findIndex(
                i => i.id == image.id
            );
            return this.store.allImages[allImagesIdx + 2];
        },
        handleTouchStart(touchEvent) {
            if (
                touchEvent.changedTouches.length !== 1 ||
                touchEvent.touches.length !== 1
            ) {
                // We only care if one finger is used
                return;
            }
            const posXStart = touchEvent.changedTouches[0].clientX;
            window.addEventListener(
                "touchend",
                touchEvent => this.handleTouchEnd(touchEvent, posXStart),
                { once: true }
            );
        },
        handleKey(e) {
            //window.addEventListener('keydown', (e) => {
            if (e.key == "ArrowRight") {
                this.handleClick();
            } else if (e.key == "ArrowLeft") {
                this.handleBackClick();
            }

            //});
        },
        handleTouchEnd(touchEvent, posXStart) {
            if (touchEvent.changedTouches.length !== 1) {
                // We only care if one finger is used
                return;
            }
            const posXEnd = touchEvent.changedTouches[0].clientX;
            if (posXStart < posXEnd) {
                this.gotoPrevImage();
            } else if (posXStart > posXEnd) {
                this.gotoNextImage();
            }
        },
        checkProjectImage() {
            this.visibleImages += 1;
            if (this.visibleImages == this.projectImages.length) {
                this.imagesVisible = true;
            }
        }
    }
};
</script>

<style scoped>
*:focus {
    outline: none;
}

#detailScrollContainer {
    overflow: hidden;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    /*background-color: rgba(0,0,0,0%);*/
    background-color: black;
}

#detailScrollContainer.allowScroll {
    scroll-behavior: smooth;
    overflow: auto;
}

#detailScrollContainer.invertedBack {
    /*background-color: rgba(0,0,0,100%);*/
}

#detailContainer {
    transition: margin 0.5s;
    position: relative;
    display: flex;
    flex-direction: column;
}

#detail {
    height: calc(var(--app-height) - 21.5rem);
    height: calc(100dvh - 21.5rem);
    width: calc(100vw - 1rem);
    /*margin-top: 16px;
    margin-bottom: 15px;*/
    margin: 9.9rem 0.5rem 3.9rem;
    /*display: flex;*/
    /*flex-direction: column;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    cursor: pointer;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    /*flex-direction: row;*/
    position: relative;

    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently*/
}

#detail.bottom {
    cursor: n-resize;
}

@media screen and (min-width: 768px) {
    #detail {
        margin: 1.7rem 0.5rem 1.6rem;
        height: calc(var(--app-height) - 8.5rem);
    }
}

@media screen and (min-width: 1000px) {
    #detail {
        margin: 4.35rem 0.5rem 4.37rem;
        height: calc(var(--app-height) - 14rem);
    }
}

#bottom {
    /*margin: 0 16px;*/
    margin: 0 1rem 0rem 0.9rem;
}

.image {
    max-width: 100%;
    max-height: 100%;
    /*max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);*/
    min-width: 0;
}

#imageCont,
#preloaderCont {
    position: absolute;
    height: 100%;
    width: calc(100% - 1rem);
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin: 0 0.5rem;
    /*align-items: center;*/
}

#imageCont {
    align-items: center;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently*/
}

#imageCont > div {
    height: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    margin: 0 0.5rem;
}

#imageCont > div:first-child {
    margin-left: 0.5rem;
}

#imageCont > div:last-child {
    margin-right: 0.5rem;
}

#preloaderCont img {
    object-fit: contain;
}

#preloaderCont {
    top: 4px;
    left: 4px;
    height: calc(100% - 8px);
    width: calc(100% - 8px);
}

#doubleImageCont {
    height: 100%;
    width: 100%;
    /*display: flex;*/
    /*align-items: center;*/
    position: relative;
    /*top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);*/
}

.doubleImageFlex {
    height: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.doubleImage {
    max-height: 100%;
    vertical-align: top;
    margin-left: 1rem;
}

.hasBorder {
    /*border: 0.03125rem solid #6b6b6b;*/
    border: 1px solid #565656;
}

.lightBorder {
    border: 0.5px solid #565656;
    box-sizing: border-box;
}

.darkBorder {
    border: 0.5px solid #202020;
    box-sizing: border-box;
}

@media screen and (min-width: 768px) {
    .lightBorder {
        border: 1px solid #565656;
        box-sizing: border-box;
    }

    .darkBorder {
        border: 1px solid #202020;
        box-sizing: border-box;
    }
}

.doubleImage:first-child {
    margin-left: 0;
}

#video {
    max-height: 100%;
    max-width: 100%;
}

#video.websiteVideo,
img.websiteImage {
    /*box-shadow: 0px 0px 3rem 0px #d2d2d2;*/
    /*border-radius: 0.25rem;*/
    border-radius: 0.4rem;
    /*max-height: calc(100% - 8rem);*/
}

/*#video.websiteVideo, img.websiteImage{
    max-height: calc(100% - 10rem);
}*/

#image.fullscreen {
    position: absolute;
    min-height: 100vh;
    min-width: 100vw;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    transition: margin 0.5s, opacity 1s;
}

#bottomTop {
    display: flex;
    justify-content: center;
    flex-direction: row;
    position: relative;
}

#detailSpacer,
#title {
    /*flex-basis: 50%;*/
}

#title {
    text-align: center;
}

#title.toggle {
    cursor: pointer;
}

#title.toggle > #titleText {
    color: #969696;
}

@media screen and (min-width: 768px) {
    #title.toggle > #titleText:hover {
        color: white;
    }
}

#title > span {
    /*white-space: nowrap;*/
}

#counter {
    text-align: center;
    margin-top: 0.8rem;
}

@media screen and (min-width: 768px) {
    #counter {
        margin-top: 1.7rem;
    }
}

.mobileCounter {
    align-self: flex-end;
    margin-top: 20px;
}

.slideUp-enter-active,
.slideUp-leave-active,
.slideDown-leave-active,
.slideDown-enter-active {
    transition: 0.7s;
}

.slideDown-enter {
    transform: translate(0, -100%);
}

.slideDown-leave-to {
    transform: translate(0, -100%);
}

.slideUp-enter {
    /*transform: translate(0, -100%);*/
    transform: translateY(-100vh);
}

.slideUp-leave-to {
    /*transform: translate(0, -100%);*/
    transform: translateY(-100vh);
}

#indexNumber {
    font-family: "JMMP Regular Tab";
}

.toggleRandom {
    cursor: pointer;
    margin-right: 15px;
}

.toggleRandomMobile {
    margin-left: 16px;
    margin-right: 16px;
}

#title > span {
    /*margin-right: 15px;*/
    /*transition: color .5s;*/
    /*overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;*/
    display: inline-block;
    /*max-width: 40vw;*/
}

#title.inverted > span,
#titleMobile.inverted > span,
#counter.inverted > span {
    color: white;
    transition: color 0.5s;
}

#toggleBottom,
#indexLink {
    cursor: pointer;
    color: #969696 !important;
    transition: color 0.5s;
}

#toggleBottom:hover,
#indexLink:hover {
    color: #232323 !important;
}

#toggleBottom.inverted:hover {
    color: white !important;
}

#description {
    margin: 1rem 1rem 0.78rem;
    color: white;
    transition: color 0.5s;
}

#description.inverted {
    /*color: black;*/
}

#description.visible {
    /*color: black;*/
}

#description.inverted.visible {
    /*color: white;*/
}

#description > p {
    /*margin: 10px 0;*/
}

#description > p:first-child {
    margin-top: 0;
}

#description > p:last-child {
    margin-bottom: 0;
}

#projectImages {
    margin: 4rem 0rem 0rem;
}

@media screen and (min-width: 1000px) {
    #projectImages {
        margin: 2rem 0rem 0rem;
    }
}

#text >>> a {
    color: #969696;
    text-decoration: none;
}

#text >>> a:hover {
    color: white;
}

#infos {
    /*margin: 15px 0;*/
}

#infos p {
    margin: 0 !important;
}

#infos > span {
    margin-right: 1rem;
}

#infos >>> a {
    color: #969696;
    text-decoration: none;
}

#infos >>> a:hover {
    color: white;
}

#leftClick {
    position: absolute;
    /*top: 33px;*/
    left: 0;
    width: 50%;
    height: 100%;
    cursor: w-resize;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently*/
}

@media screen and (min-width: 768px) {
    #leftClick {
        width: 40%;
    }
}

#middleClick {
    position: absolute;
    /*top: 33px;*/
    left: 40%;
    width: 20%;
    height: 100%;
    cursor: default;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently*/
}

#middleClick.hasBottom {
    cursor: s-resize;
}

#rightClick {
    position: absolute;
    /*top: 33px;*/
    right: 0;
    width: 50%;
    height: 100%;
    cursor: e-resize;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently*/
}

@media screen and (min-width: 768px) {
    #rightClick {
        width: 40%;
    }
}

#eyeCatcher {
    position: absolute;
    top: 2rem;
    right: 2rem;
    background-color: red;
    width: 6rem;
    height: 6rem;
    border-radius: 6rem;
    box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.5);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: rotate(20deg);
    text-align: center;
    font-size: 0.667rem;
}

@media screen and (min-width: 768px) {
    #eyeCatcher {
        top: 6rem;
        right: 6rem;
        width: 12rem;
        height: 12rem;
        font-size: 1rem;
    }
}

span#eyeCatcher {
    cursor: default;
}

#eyeCatcher > span {
    padding: 1rem;
}

a {
    color: #969696;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.5s;
}

a:hover {
    color: #232323;
}

a.inverted:hover {
    color: white;
}

.preloader {
    /*background-color: lightgrey;
    width: 100px;
    height: 200px;*/
    /*height: 97%;
    width: 97%;*/
    filter: blur(2px);
    margin: 0 calc(0.5rem + 3px);
}

/*
.preloader2{
    width: 100px;
    height: 200px;
    background-color: lightgreen;
    margin-left: 1.5rem;
    max-height: 97%;
    height: 97%;
    filter: blur(2px);
}
*/

#titleMobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.5rem;
}

#titleMobile span {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    white-space: nowrap;
}

#bottomLinkMobile {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

#bottomMobile {
    position: absolute;
    top: 0;
    left: 0;
    margin: 0 0 1rem;
    padding: 0.7rem 1rem 1rem;
    background-color: white;
    height: 100vh;
    width: calc(100vw - 2rem);
    overflow: scroll;
}

#bottomMobile > .text {
    padding-bottom: 14rem;
}

#bottomMobile > .hide > .title {
    text-align: center;
    margin: 0 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    white-space: nowrap;
}

#bottomMobile p {
    margin: 0 0 1em;
}

#bottomMobile > .hide {
    position: fixed;
    padding: 3rem 0 2.15rem;
    bottom: 0;
    width: calc(100% - 2rem);
    background-color: white;
    box-shadow: 0 0 4rem 4rem white;
}

#bottomMobile > .hide > .text {
    text-align: center;
    margin: 0 auto;
    color: #969696;
}

@media screen and (min-width: 768px) {
    #text,
    #infos {
        max-width: 50%;
    }
}

#bottomMobile #text,
#bottomMobile #infos {
    max-width: 100%;
}

section {
    display: flex;
    flex-wrap: wrap;
    margin: 0rem 1rem 0.75rem;
    position: relative;
    /*top: 10.8rem;*/
    width: calc(100vw - 2rem);
}

@media screen and (min-width: 768px) {
    section {
        /*top: 3.55rem;*/
        margin: 0.5rem 0.75rem 0.5rem;
        width: calc(100vw - 1.5rem);
        /*margin: 0.2rem 0.75rem 0.75rem;*/
    }
}

section::after {
    content: "";
    flex-grow: 999999999;
}

div.imageElement {
    position: relative;
    margin: 0.25rem 0.25rem 0;
    color: #969696;
}

div.imageElement:hover {
    color: white;
}

i {
    display: block;
}

div.imageElement > p {
    text-align: center;
    margin: 0.1rem 0 0rem;
}

@media screen and (min-width: 768px) {
    div.imageElement > p {
        margin: 0.25rem 0 0.08rem;
    }
}

img.projectImage {
    position: absolute;
    top: 0;
    width: 100%;
    vertical-align: bottom;
    object-fit: cover;
    cursor: pointer;
}

img.projectImage.websiteImage {
    /*box-shadow: 0px 0px 0.3rem 0px #d2d2d2;*/
    border-radius: 0.25rem;
}

img.projectImage.double {
    width: calc(50% - 0.25rem);
}

img.projectImage.double:nth-child(3) {
    left: calc(50% + 0.25rem);
}

img.projectImage.triple {
    width: calc(33% - 0.25rem);
}

img.projectImage.triple:nth-child(3) {
    left: calc(33% + 0.25rem);
}

img.projectImage.triple:nth-child(4) {
    left: calc(66% + 0.5rem);
}

#mobileImages {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row-gap: 1rem;
    grid-column-gap: 1rem;
    margin-bottom: -0.4rem;
}

#mobileImages img {
    position: static;
    max-width: 100%;
    /*max-height: calc(100% - 2.5rem);*/
    max-height: calc(28vw - 2.6rem);
    width: auto;
    /*object-fit: contain;*/
    /*object-fit: cover;*/
}

#mobileImages img.double {
    width: calc(50% - 0.26rem);
    margin-left: 0.5rem;
    object-position: left;
}

#mobileImages img.double:first-child {
    margin-left: 0;
    object-position: right;
}

#mobileImages img.triple {
    width: calc(32% - 0.26rem);
    margin-left: 0.5rem;
    object-position: center;
}

#mobileImages > div {
    height: calc(33vw - 1rem);
    text-align: center;
    position: relative;
}

#mobileImages > div > p {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
}

.nobreak {
    white-space: nowrap;
}

.lds-spinner {
    color: official;
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    transform: scale(0.5);
}

.lds-spinner2 {
    position: relative;
    margin: 4rem 0;
}

.lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #fff;
}

.lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}

@keyframes lds-spinner {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.appear-enter-active,
.appear-leave-active {
    transition: opacity 0.5s;
}

.appear-enter,
.appear-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}

.short-appear-enter-active,
.short-appear-leave-active {
    transition: opacity 0.2s;
}

.short-appear-enter,
.short-appear-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}

.long-appear-enter-active,
.long-appear-leave-active {
    transition: opacity 1s;
}

.long-appear-enter,
.long-appear-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}
</style>
